module.exports = __webpack_public_path__ + "media/images/reseller-page--c294ef9f.jpg";